module.exports = "<i class=\"icon-filter\"></i> <input class=\"search-input\" type=\"text\" ng-change=\"$ctrl.searchFilters()\" placeholder=\"{{:: 'Поиск - имя или содержимое фильтра' | gettext }}\" ng-model=\"$ctrl.layout.searchTrim\"><div class=\"clear-buttom\"><button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"$ctrl.searchClean()\">&times;</button></div>"


//////////////////
// WEBPACK FOOTER
// ./src/filter/catalog/catalog-search.component.html
// module id = 796
// module chunks = 0